import {LoaderFunctionArgs} from 'react-router-dom';
import {getAppTracer} from '../../../app.tracer';
import {resolveUserAndAccount} from '../helper/auth-resolve.helper';
import {IChangePasswordStore, ChangePasswordStore} from './change-password.stores';

const trace = getAppTracer('change-password.loader');

export async function changePasswordRouteLoader(args: LoaderFunctionArgs): Promise<IChangePasswordStore | void> {
    trace.info('Starting');

    const {currentUser, accountData} = await resolveUserAndAccount();

    const store = new ChangePasswordStore(currentUser, accountData);

    trace.info('Completed successfully');
    return store;
}
